export default __webpack_public_path__ + "static/media/020306202135103.76efca5e.png";